import server from "../../../server";
import React, { useEffect, useState} from "react";
import {IAssetRequestCount} from "./types/asset-card.types";
import StatsChart from "../../common/stats-chart/stats-chart";
import {PieChart as PieIcon} from "lucide-react";
import AssetSummaryChart from "./asset-summary-chart";
import {useNavigate} from 'react-router-dom';
import dayjs from 'dayjs';
import Locale from "../../../core/locale/locale";

const initialAssetRequestCount: IAssetRequestCount = {
    requestAnalysis: {
        summary: {
            accepted: 0,
            cancelled: 0,
            pending: 0,
            rejected: 0,
            total: 0,
            allocated: 0,
            acceptedPercentage: 0.0,
            allocatedPercentage: 0.0,
            rejectedPercentage: 0.0,
            pendingPercentage: 0.0,
            cancelledPercentage: 0.0
        }
    }
}

const AssetRequestSummary = () => {
    const [assetRequestCount, setAssetRequestCount] = useState<IAssetRequestCount>(initialAssetRequestCount);
    const [loading, setLoading] = useState(true);
    const navigate=useNavigate();

    async function fetchAssetRequestsSummary() {
            setLoading(true);
            try {
                const startDate=dayjs().startOf('year').format(Locale.dateFormat);
                const endDate=dayjs().endOf('year').format(Locale.dateFormat);
                const AssetsRequestCount = await server.asset.analysis(startDate, endDate);
                setAssetRequestCount(AssetsRequestCount);
            } catch (e) {
                console.log("Error while fetching asset requests count", e);
            } finally {
                setLoading(false);
            }
    }

    const handleOnClick = () => {
        navigate('/asset/request')
    }

    useEffect(() => {
        fetchAssetRequestsSummary();
    }, []);

    return (
            <StatsChart
                icon={PieIcon}
                title="Asset Requests Analysis"
                badge={{
                    text: `${assetRequestCount?.requestAnalysis.summary.total ? `${assetRequestCount.requestAnalysis.summary.total} Asset Requests ` : ""} `,
                    color: "red"
                }}
                onClick={handleOnClick}
                subtitle={'This year\'s asset request overview.'}
                className={'dashboard-asset-card'}
            >
                <AssetSummaryChart assetRequestCount={assetRequestCount} loading={loading}/>
            </StatsChart>
    )
}

export default AssetRequestSummary;
